// Import metronic dependencies
import '../../vendor/metronic/webpack/vendors/global';
import '../../vendor/metronic/webpack/scripts';

// Sanitizer used by the alerts view before injecting flash messages into swal
import DOMPurify from 'dompurify';
window.DOMPurify = DOMPurify;

// Require international phone formatter
import intlTelInput from "intl-tel-input/build/js/intlTelInputWithUtils.js";
window.intlTelInput = intlTelInput;

// Import payment card icons
import visa from 'payment-icons/min/flat/visa.svg';
import amex from 'payment-icons/min/flat/amex.svg';
import discover from 'payment-icons/min/flat/discover.svg';
import diners from 'payment-icons/min/flat/diners.svg';
import jcb from 'payment-icons/min/flat/jcb.svg';
import mastercard_old from 'payment-icons/min/flat/mastercard-old.svg';
import default_card from 'payment-icons/min/flat/default.svg';

// Initialize tooltips
$(document).ready(function(){
    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
        boundary: 'window'
    });

    // Spin buttons on submit forms
    $("form.spinner").on('submit', function() {
        $(this).find(":submit:not(.kt-login__btn-primary)").addClass("kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light");
        $(this).find(":submit.kt-login__btn-primary").html("").addClass("kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--light");
    });
});

// Function to require at least one checkbox in a group
window.requireCheckbox = function (elClass) {
    let el=document.getElementsByClassName(elClass);

    let atLeastOneChecked = false;
    for (let i=0; i<el.length; i++) {
        if (el[i].checked === true) {
            atLeastOneChecked=true;
        }
    }

    if (atLeastOneChecked === true) {
        for (let i=0; i<el.length; i++) {
            el[i].required = false;
        }
    } else {
        for (let i=0; i<el.length; i++) {
            el[i].required = true;
        }
    }
};
